import { render, staticRenderFns } from "./Regist.vue?vue&type=template&id=231684b0&scoped=true&"
import script from "./Regist.vue?vue&type=script&lang=js&"
export * from "./Regist.vue?vue&type=script&lang=js&"
import style0 from "./Regist.vue?vue&type=style&index=0&id=231684b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231684b0",
  null
  
)

export default component.exports